import ProductContentSections from './ProductContentSections'

export default ProductContentSections
